import { render, staticRenderFns } from "./StudyProgramMajorAdd.vue?vue&type=template&id=2bb137ae&"
import script from "./StudyProgramMajorAdd.vue?vue&type=script&lang=js&"
export * from "./StudyProgramMajorAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports